import { render, staticRenderFns } from "./NotificationControlBar.vue?vue&type=template&id=307aa2a6&scoped=true&"
import script from "./NotificationControlBar.vue?vue&type=script&lang=js&"
export * from "./NotificationControlBar.vue?vue&type=script&lang=js&"
import style0 from "./NotificationControlBar.vue?vue&type=style&index=0&id=307aa2a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307aa2a6",
  null
  
)

export default component.exports